<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb-group">
      <span class="breadcrumb-item" @click="gotoPage('/home')">首页</span>
      <span class="separator">/</span>
      <span class="breadcrumb-item" @click="gotoPage('/coreTechnology/index')">核心技术</span>
      <span class="separator">/</span>
      <span class="breadcrumb-item current">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {

    }
  },
  methods: {
    gotoPage(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  padding: 16px 0;
  font-size: 14px;
  color: rgb(48, 49, 51);
  font-weight: 600;
  box-shadow: rgb(221, 221, 221) 0 2px 2px 0;

  .breadcrumb-group {
    width: 94%;
    max-width: 1280px;
    margin: 0 auto;
  }
  .breadcrumb-item {
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #0555b6;
    }

    &.current {
      color: rgb(151, 168, 190);
      cursor: default;
    }
  }

  .separator {
    margin: 0 9px;
    color: rgb(151, 168, 190);
  }
}
</style>
